var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showtitle)?_c('div',{staticClass:"sf-heading"},[_c('h3',{staticClass:"sf-heading__title h3"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('HTMLContent',{attrs:{"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }